module.exports = __webpack_public_path__ + "img/trunk_6x3_z16.c2e40da1.svg";